import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { mergeClasses } from '@/helpers/styling'
import { CheckIcon } from '@radix-ui/react-icons'
import { useFormFieldId } from './form'

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  const defaultId = useFormFieldId()
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      id={defaultId}
      className={mergeClasses(
        "peer m-0 h-3.5 w-3.5 shrink-0 rounded-[4px] !border border-[#51479e]/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#51479e]/40 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:!border-[#51479e] data-[state=checked]:bg-[#51479e] data-[state=checked]:text-white",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={mergeClasses("flex items-center justify-center text-current")}
      >
        <CheckIcon className="h-3 w-3" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = "Checkbox"
